module.exports = __webpack_public_path__ + "img/Bordeaux.51d61e40.png";